export enum MultimediaType {
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Other = 'OTHER',
  Presentation = 'PRESENTATION',
  Spreadsheet = 'SPREADSHEET',
  Video = 'VIDEO',
  Archive = 'ARCHIVE',
}
